// ONE period scope for every number on the Deals page (owner task 2026-10-29).
//
// The page had two copies of its date gate — one inside `dealsInPeriod` (the
// All / Internal / External / Ambassador pills) and one inside `filteredDeals`
// (the rows and the Total pill) — while the Active / Cancelled chips and the
// "⏳ pending approval" pill counted the UNSCOPED tab sets. Under Q4 the chip
// read "Active (52)" above a Total and a row set that only knew about the
// quarter. This is that gate as one pure function, so every count on the page
// is `rows.filter(inPeriod)` of the same predicate and a gate can RUN it.
//
// Semantics are the shipped ones, unchanged:
//   • a manual From/To range takes full control — Quarter + Year are skipped;
//     bounds are inclusive calendar days compared as "YYYY-MM-DD" strings; a
//     row with no/invalid date is INCLUDED (never silently dropped by a range);
//   • otherwise Quarter (when not "all") requires a date and matches its
//     calendar quarter; Year (when not "all") compares getFullYear() of the
//     date, so a missing date reads as 1970 and is excluded;
//   • "all" quarter + "all" year + no range = everything (today's numbers).
// `getDate` is the page's own getDealDate and `toYMD` its local-calendar
// formatter, passed in so this file never grows a second copy of either.
export function dealDateScopeOk(row, scope, getDate, toYMD) {
  var hasManualRange = !!(scope.from || scope.to);
  if (!hasManualRange) {
    if (scope.q !== "all") {
      var dd = getDate(row); if (!dd) return false;
      var m = new Date(dd).getMonth(); var q = m < 3 ? "Q1" : m < 6 ? "Q2" : m < 9 ? "Q3" : "Q4";
      if (q !== scope.q) return false;
    }
    if (scope.year !== "all" && new Date(getDate(row) || 0).getFullYear() !== scope.year) return false;
    return true;
  }
  var ds = toYMD(getDate(row));
  if (ds) {
    if (scope.from && ds < scope.from) return false;
    if (scope.to && ds > scope.to) return false;
  }
  return true;
}
